import TranslateDrink from "@/views/admin/translate/TranslateDrink";

export default {
  path: "translate/drink",
  name: "TranslateDrink",
  component: TranslateDrink,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
